import { withUserGuard } from '@utils/guards/withUserGuard.component'

import { EditEmailAutoPage } from './edit-email-auto.page'

export * from './edit-email-auto.page'

export const GuardEditEmailAutoPage = withUserGuard(EditEmailAutoPage)
